<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/lPmhVC/tc-custom/9780811872744.jpg?1737752448397" alt="This image is the cover for the book Sticky, Chewy, Messy, Gooey"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sticky, Chewy, Messy, Gooey
      </h1>
      <p class="bookDescription body article font2">
        <b>A collection of dessert recipes that gives you more than seventy-five delicious reasons to stock up on napkins.</b><br/><br/>Chocolate Caramel-Pecan Soufflé Cake<br/><br/>Cinnamon-Donut Bread Pudding<br/><br/>Chewy Lemon-Pistachio Financiers<br/><br/>Double-Crumble Hot Apple Pies<br/><br/>Butterscotch-Bourbon Macadamia Nut Pie<br/><br/>Still not satisfied? How about Cheesecake Pops, Giant Coconut Cream Puffs, Hawaiian Caramel Corn, Milky Way Tempura-on-a-Stick, or Sticky Pear and Walnut Upside-Down Gingerbread? And there are plenty more where that came from.<br/><br/>In addition to each buttery, sugary favorite, author Jill O’Connor has included all the techniques and tools you’ll need to re-create these perfectly decadent treasures. Sprinkled throughout are sweet tips on using phyllo dough, toasting nuts, choosing the right cocoa, and making a heavenly ganache, ensuring that every pudding, cookie, cake, pie, and over-the-top treat tastes as irresistible as it sounds.<br/><br/>If you think chocolate, marshmallow, whipped cream, and caramel belong in a separate food group all their own, you’re ready to bite into all that’s <i>Sticky, Chewy, Messy, Gooey</i>.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jill O'Connor, Leigh Beisch
      </h2>
      
      <p class="authorDescription body article">Graduate of the Cordon Bleu Cooking School in London, Jill O'Connor has authored Phyllo, Easter Treats, and Simple French Desserts. She lives in Coronado, California.Leigh Beisch is a San Francisco-based photographer. Her work has appeared in Irish Puddings and Gentlemen, Start Your Ovens.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Chronicle Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5bafc544